export const styles = {
    card: { width: 350, display: 'flex', flexDirection: 'column' },
    content: { flexGrow: 1 },
};
